const txt = 'Vous trouverez ci-dessous les projets et présentations auxquels j’ai contribué.';

export default txt;
